<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="{ path: 'message.title_add_object', args: { objectName: $t('message.title_stt_extension_dictionary') } }">
                </div>
                <hr class="dialog-hr">
                <el-form label-width="200px" @submit.native.prevent="saveDictionary()">
                    <div class="confirm-body">
                        <el-form-item prop="dictionaryName" ref="dictionaryName">
                            <div slot="label" style="text-align:left" v-t="'message.item_stt_extension_dictionary_display_name'"></div>
                            <el-input id="dictionaryName" v-model="dictionaryName.value" type="text"
                                    @compositionstart.native="compositionStart()" @compositionend.native="compositionEnd()" @input.native="inputCheck()"/>
                        </el-form-item>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" :disabled="disableSave" native-type="submit" v-t="'message.button_save'"></el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '@/components/common-validate.js';

export default {
    data() {
        return {
            disableSave: true,
            dictionaryName: {validationRule: "reqDisplayName", value: null, isComposing: false},
        };
    },

    methods: {
        inputCheck() {
            if (this.dictionaryName.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.dictionaryName.validationRule, this.dictionaryName.value);
            if (validateResult.valid) {
                this.$emit('validateDictNameDuplicated', this.dictionaryName.value, this.updateNameState)
            } else {
                this.updateNameState(false, validateResult.message)
            }
        },
        updateNameState(valid, message) {
            if (valid) {
                this.disableSave = false;
                this.$refs.dictionaryName.clearValidate();
            } else {
                this.disableSave = true;
                this.$refs.dictionaryName.validateState = "error";
                this.$refs.dictionaryName.validateMessage = message;
            }
        },
        compositionStart() {
            this.dictionaryName.isComposing = true;
        },
        compositionEnd() {
            this.dictionaryName.isComposing = false;
            this.inputCheck()
        },
        saveDictionary() {
            this.$emit('save', this.dictionaryName.value);
        },
    }
}
</script>

<style scoped>
.setting-items {
    padding-top: 10px;
}

.setting-items >>> .el-slider__button {
    width: 12px;
    height: 12px;
    background-color: #5171cb;
    border: #5171cb;
}

.setting-items >>> .el-slider__bar {
    background-color: #5171cb;
}
</style>
